import { CapsuleSingleSelectDropdown } from "@screencloud/screencloud-ui-components";
import { useMemo } from "react";
import { ALL_OPTION, AuditLogFilterProps } from "./const";

const ACTION_OPTIONS = [
  {
    key: "created",
    text: "Created",
    value: "I",
  },
  {
    key: "updated",
    text: "Updated",
    value: "U",
  },
  {
    key: "deleted",
    text: "Deleted",
    value: "D",
  },
];

export const ActionFilter = (props: AuditLogFilterProps) => {
  const actionOptions = useMemo(() => [ALL_OPTION, ...ACTION_OPTIONS], []);

  return (
    <CapsuleSingleSelectDropdown
      label="Actions"
      optionHeader="Actions"
      options={actionOptions}
      onChange={props.onChange}
      defaultValue={null}
      value={props.value}
      position={props.popoverPosition}
    />
  );
};
